module.exports = __webpack_public_path__ + "images/category_lp/jewel/new/assessment_achievements/3_b3e52c04336edcc5b73e1bb2a3750573.png";